import React, {useCallback, useEffect, useReducer, useState} from 'react'
import {BrowserRouter} from 'react-router-dom'

import requestHandler from 'utils/requestHandler'
import {logInUser} from 'utils/user'
import {usersService} from 'services'
import UserContext from 'components/User/UserContext'
import CartContext, {cartReducer, defaultCart} from 'components/Cart/CartContext'
import SearchContext from 'components/SearchContext'
import Loader from 'components/Loader'
import ModalAddress from 'modules/UserProfile/ModalAddress'

const storageCart = localStorage.getItem('cart')
const storageZip = JSON.parse(localStorage.getItem('zip'))
const storageDeliveryUuid = localStorage.getItem('deliveryAddressUuid')

const GlobalContexts = ({children}) => {
  const [user, setUser] = useState(null)
  const [delivery, setDelivery] = useState(storageZip ?? null)
  const [deliveryModal, setDeliveryModal] = useState(null)
  const [cartVisible, setCartVisible] = useState(false)
  const [cartState, cartDispatch] = useReducer(
    cartReducer,
    storageCart ? (
      {items: JSON.parse(storageCart), discounts: [], points: 0}
    ) : defaultCart)
  const [loading, setLoading] = useState(true)
  const [searchMode, setSearchMode] = useState(undefined)
  const [catTitle, setCatTitle] = useState(undefined)

  const openDeliveryModal = useCallback(() => setDeliveryModal(true), [])

  const tokenRefresher = useCallback(() => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user) {
      usersService.authRefresh({username: user.email, refreshToken: user.refreshToken})
        .then(r => r.ok ? r.json() : r)
        .then(response => {
          if (response.success) {
            setDelivery(response.data.customerProfile.deliveryAddresses.filter(e => e.uuid === storageDeliveryUuid)[0])
            logInUser(response, setUser)
          }
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    tokenRefresher()
    requestHandler.tokenRefresher = tokenRefresher
  }, [tokenRefresher])

  useEffect(() => {
    setDelivery(d => d ? user?.customerProfile.deliveryAddresses?.filter(e => e.uuid === d.uuid)[0] : d)
  }, [user])

  return (
    <BrowserRouter basename='/buildiroShop/#/'>
      <UserContext.Provider value={{user, setUser, delivery, setDelivery, openDeliveryModal}}>
        <CartContext.Provider value={{cart: cartState, cartDispatch, cartVisible, setCartVisible}}>
          <SearchContext.Provider value={{mode: searchMode, setMode: setSearchMode, catTitle, setCatTitle}}>
            {loading ? <Loader/> : <>
              {children}

              <ModalAddress deliveryModal={deliveryModal} setDeliveryModal={setDeliveryModal}/>
            </>}
          </SearchContext.Provider>
        </CartContext.Provider>
      </UserContext.Provider>
    </BrowserRouter>
  )
}

export default GlobalContexts
